import { render, staticRenderFns } from "./Exams.vue?vue&type=template&id=bb67ce88&scoped=true&"
import script from "./Exams.vue?vue&type=script&lang=js&"
export * from "./Exams.vue?vue&type=script&lang=js&"
import style0 from "./Exams.vue?vue&type=style&index=0&id=bb67ce88&scoped=true&lang=scss&"
import style1 from "./Exams.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb67ce88",
  null
  
)

export default component.exports